import styled from 'styled-components';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background};
  @media (max-width: 767px) {
    padding: 0px 0px 72px;
  }
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 136px);
  height: fit-content;
  padding: 0 15px 15px;
`;

export const TabsWrapper = styled.div`
  display: inline-flex;
  width: 570px;
  margin: 0px auto 30px;
  justify-content: space-between;
  border-bottom: 1px solid #767676;
  @media (max-width: 580px) {
    width: 100%;
  }
`;

export const Tab = styled.div`
  padding: 30px 0 5px;
  width: fit-content;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.line};
  margin-bottom: 3px;
  &.unlocked {
    color: #767676;
    /* cursor: pointer; */
  }
  &.active {
    color: ${({ theme }) => theme.colors.main};
    border-bottom: 3px solid ${({ theme }) => theme.colors.main};
    margin-bottom: 0px;
  }
  @media (max-width: 580px) {
    display: none;
    &.active {
      display: block;
    }
  }
`;

export const Warning = styled.div`
  margin: 21px;
  width: 100%;
  font-size: 21px;
  text-align: center;
`;
